import { combineEpics, type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { createEventRequest } from '@/api/events';
import { navigate } from '@/slices/app';
import i18n from '@/i18n';
import { createEvent, tryFetchEvents } from '../actions';

const createEventEpic: Epic = (action$) =>
  action$.pipe(
    filter(createEvent.match),
    request(({ payload }) => createEventRequest(payload), createEvent),
  );

const createEventSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(createEvent.succeeded.match),
    mergeMap(
      ({
        payload: {
          originalData: { property_id: propertyId },
        },
      }) => [
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: i18n.t('CREATE_EVENT_SUCCESS'),
        }),
        navigate({ to: `/events/${propertyId}` }),
        tryFetchEvents({
          propertyId,
          pagination: { page: 1 },
          filters: { statusIds: [], typeIds: [] },
        }),
      ],
    ),
  );

export default combineEpics(createEventEpic, createEventSucceededEpic);
